import { isClerkAPIResponseError } from '@clerk/clerk-react/errors';

const CLERK_ERROR_MESSAGES: Record<string, string> = {
  form_password_pwned:
    'Ce mot de passe est trop commun ou a été compromis dans une fuite de données. Veuillez en choisir un autre plus unique.',
  form_password_incorrect:
    'Mot de passe incorrect. Veuillez réessayer.',
  form_password_too_short:
    'Votre mot de passe doit contenir au moins 8 caractères.',
  form_identifier_not_found:
    "Aucun compte trouvé avec cette adresse courriel.",
  form_identifier_exists:
    'Un compte existe déjà avec cette adresse courriel. Veuillez vous connecter.',
  form_code_incorrect:
    'Code de vérification invalide. Vérifiez votre courriel et réessayez.',
  form_param_format_invalid:
    'Format invalide. Veuillez vérifier les informations saisies.',
  too_many_requests:
    'Trop de tentatives. Veuillez patienter quelques minutes avant de réessayer.',
  session_exists:
    'Vous êtes déjà connecté(e).',
};

export function getClerkErrorMessage(err: unknown): string {
  if (isClerkAPIResponseError(err)) {
    const first = err.errors?.[0];
    const code = first?.code ?? '';

    // Friendly French message takes priority
    if (code && CLERK_ERROR_MESSAGES[code]) {
      return CLERK_ERROR_MESSAGES[code];
    }

    // In dev, show the raw message + code for easier debugging
    if (import.meta.env.DEV && code) {
      const text = first?.longMessage ?? first?.message ?? null;
      return text ? `${text} [${code}]` : `Erreur Clerk : ${code}`;
    }

    return first?.longMessage ?? first?.message ?? 'Une erreur est survenue.';
  }
  if (err instanceof Error) return err.message;
  return 'Une erreur est survenue.';
}

/** Returns true when Clerk rejects the password (wrong credentials), not for other errors. */
export function isPasswordIncorrectError(err: unknown): boolean {
  if (!isClerkAPIResponseError(err)) return false;
  return err.errors?.some((e) => e.code === 'form_password_incorrect') ?? false;
}

/** Returns true when Clerk cannot find an account for the given identifier. */
export function isAccountNotFoundError(err: unknown): boolean {
  if (!isClerkAPIResponseError(err)) return false;
  return err.errors?.some((e) => e.code === 'form_identifier_not_found') ?? false;
}
